import businessClient from 'src/services/clients/business'
import { IMeta, ISalesType } from 'src/common/interfaces/index.js'

const ISettingsSalesTypeResponse = { meta: IMeta, date: { list: [ISalesType] } }

export const settingsSalesType = {
  /**
   * @param {{store_id: number}} filter
   * @return {Promise<ISettingsSalesTypeResponse>}
   */
  list(filter, signal) {
    return businessClient().post('sales-types/portal/list', { filter }, { signal })
  },
}
